<template>
  <v-breadcrumbs :items="navigation">
    <template v-slot:item="link">
      <v-breadcrumbs-item
        :key="link.item.id"
        :to="link.item.href"
        :disabled="link.item.disabled"
        :exact="true"
      >{{ link.item.text }}</v-breadcrumbs-item>
    </template>
    <!-- <v-breadcrumbs-item
      v-for="link in navigation"
      :key="link.id"
      :to="link.to"
      :disabled="false"
      :exact="true"
    >{{ link.text }}</v-breadcrumbs-item>-->
  </v-breadcrumbs>
</template>

<script>
export default {
  props: ["navigation"]
};
</script>